/* ======================================================
   OGP Graduated Bundle — SINGLE FILE (FINAL)
   File: assets/ogp-graduated.bundle.js
====================================================== */
(function () {
  "use strict";

  /* =======================
     CONFIG MAP
  ======================= */
  const OGP_LENS_MAP = window.OGP_LENS_MAP || {
    "1.50": { label: "1.50 Basic", base: { id: 56264478294364, priceCents: 4900, includes: ["uv"] }, addons: { ar:{id:56239773319516,priceCents:2000}, blue:{id:56239774105948,priceCents:3000}, totalblue:{id:56239790457180,priceCents:6500}, drive:{id:56239797043548,priceCents:8000} } },
    "1.60": { label: "1.60 Comfort", base: { id: 56264591343964, priceCents: 9900, includes: ["ar"] }, addons: { blue:{id:56239785705820,priceCents:1500}, totalblue:{id:56239790489948,priceCents:3500}, drive:{id:56239797076316,priceCents:5000} } },
    "1.67": { label: "1.67 Slim", base: { id: 56264591376732, priceCents: 12400, includes: ["ar"] }, addons: { blue:{id:56239785738588,priceCents:1500}, totalblue:{id:56239790522716,priceCents:3500}, drive:{id:56239797109084,priceCents:5000} } },
    "1.74": { label: "1.74 Ultra Slim", base: { id: 56264591409500, priceCents: 13900, includes: ["ar"] }, addons: { blue:{id:56239785771356,priceCents:1500}, totalblue:{id:56239790555484,priceCents:3500}, drive:{id:56239797141852,priceCents:8000} } }
  };

  const OGP_TREATMENTS = window.OGP_TREATMENTS || [
    { key: "uv",        label: "UV Block",           availableFor: ["1.50"] },
    { key: "ar",        label: "AR Classico",        availableFor: ["1.50"] },
    { key: "blue",      label: "Blocco Luce Blu",    availableFor: ["1.50", "1.60", "1.67", "1.74"] },
    { key: "totalblue", label: "Total Blue UVBlock", availableFor: ["1.50", "1.60", "1.67", "1.74"] },
    { key: "drive",     label: "AR Drive Top",       availableFor: ["1.50", "1.60", "1.67", "1.74"] }
  ];

  const qs  = (s, root = document) => root.querySelector(s);
  const qsa = (s, root = document) => Array.from(root.querySelectorAll(s));

  function getUrlParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }
  function isEditMode() {
    const v = (getUrlParam("edit") || "").toLowerCase();
    return v === "1" || v === "true" || v === "yes";
  }
  function buildGroupId() {
    return `ogp_${Date.now()}_${Math.random().toString(16).slice(2)}`;
  }
  function safeNum(v) {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  }
  function money(cents) {
    return `€${(safeNum(cents) / 100).toFixed(2)}`;
  }

  async function fetchJson(url) {
    const r = await fetch(url, { headers: { Accept: "application/json" }, credentials: "same-origin", cache: "no-store" });
    if (!r.ok) throw new Error(`Fetch failed: ${url}`);
    return r.json();
  }

  async function cartChangeByKey(key, quantity) {
    const r = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      cache: "no-store",
      body: JSON.stringify({ id: key, quantity })
    });
    if (!r.ok) throw new Error(`cart/change.js failed (${r.status})`);
    return r.json();
  }

  async function cartAddJson(items) {
    const r = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      cache: "no-store",
      body: JSON.stringify({ items })
    });
    if (!r.ok) {
      let body = "";
      try { body = await r.text(); } catch (_) {}
      const err = new Error(body || `cart/add.js failed (${r.status})`);
      err.status = r.status;
      err.body = body;
      throw err;
    }
    return true;
  }

 // ✅ FormData add (supporta file) — FIX status 0 (opaque redirect)
async function cartAddFormDataOne(item, file, filePropName) {
  const fd = new FormData();
  fd.append("id", String(item.id));
  fd.append("quantity", String(item.quantity || 1));

  const props = item.properties || {};
  Object.keys(props).forEach(k => fd.append(`properties[${k}]`, String(props[k])));

  if (file) fd.append(`properties[${filePropName}]`, file);

  const r = await fetch("/cart/add.js", {
    method: "POST",
    headers: { Accept: "application/json" },
    body: fd,
    credentials: "same-origin",
    cache: "no-store"
  });

  if (!r.ok) {
    let body = "";
    try { body = await r.text(); } catch (_) {}
    const err = new Error(body || `cart/add.js failed (${r.status})`);
    err.status = r.status;
    err.body = body;
    throw err;
  }

  return true;
}


  async function removeAllItemsInGroup(groupId) {
    const cart = await fetchJson("/cart.js");
    const keysToRemove = [];
    (cart.items || []).forEach(it => {
      const g = it.properties && it.properties._ogp_group;
      if (g === groupId) keysToRemove.push(it.key);
    });
    for (const key of keysToRemove) await cartChangeByKey(key, 0);
  }

  async function removeItemsByVariantIds(variantIds) {
    const set = new Set((variantIds || []).map(Number).filter(Boolean));
    if (!set.size) return;

    const cart = await fetchJson("/cart.js");
    const keys = (cart.items || []).filter(it => set.has(Number(it.variant_id))).map(it => it.key);
    for (const k of keys) await cartChangeByKey(k, 0);
  }

  function getSelectedVariantIdFromProductForm(el) {
    const form = el.closest("form[action*='/cart/add']") || qs("form[action*='/cart/add']");
    if (!form) return null;
    const idInput = qs("input[name='id']", form);
    const v = idInput ? Number(idInput.value) : null;
    return v && Number.isFinite(v) ? v : null;
  }

  function patchConfiguratorLinks() {
    qsa("a.ogp-configurator-link[href*='/pages/configuratore-lenti'], a[href*='/pages/configuratore-lenti']").forEach(a => {
      a.addEventListener("click", (e) => {
        const vId = getSelectedVariantIdFromProductForm(a);
        if (!vId) return;

        const href = a.getAttribute("href") || "";
        try {
          const url = new URL(href, window.location.origin);
          if (!url.searchParams.get("product")) return;
          url.searchParams.set("variant", String(vId));
          e.preventDefault();
          window.location.href = url.toString();
        } catch (_) {}
      }, { passive: false });
    });
  }

  /* =======================
     MODAL
  ======================= */
  function showModal(title, text, items) {
    const modal = qs("#ogp-modal");
    const tEl = qs("#ogp-modal-title");
    const pEl = qs("#ogp-modal-text");
    const listEl = qs("#ogp-modal-list");

    if (!modal || !tEl || !pEl || !listEl) {
      alert([title, text, ...(items || [])].filter(Boolean).join("\n"));
      return;
    }

    tEl.textContent = title || "Controlla i dati";
    pEl.textContent = text || "Completa i campi richiesti prima di continuare.";
    listEl.innerHTML = "";

    (items || []).forEach(x => {
      const li = document.createElement("li");
      li.textContent = x;
      listEl.appendChild(li);
    });

    modal.style.display = "block";
    modal.setAttribute("aria-hidden", "false");
  }

  function closeModal() {
    const modal = qs("#ogp-modal");
    if (!modal) return;
    modal.style.display = "none";
    modal.setAttribute("aria-hidden", "true");
  }

  function initModalListeners() {
    qsa("[data-ogp-modal-close]").forEach(el => el.addEventListener("click", closeModal));
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeModal(); });
  }

  async function initConfiguratorIfPresent() {
    const indiceContainer = qs("#ogp-indice-container");
    const trattamentiContainer = qs("#ogp-trattamenti-container");
    const addToCartBtn = qs("#ogp-add-to-cart");
    if (!indiceContainer || !trattamentiContainer) return;

    initModalListeners();

    const steps = qsa(".ogp-step");
    const navItems = qsa(".ogp-step-nav-item");
    const progressBar = qs("#ogp-progress-bar");

    const frameNameEl = qs("#ogp-frame-name");
    const frameImgEl = qs("#ogp-frame-image");

    const previewIndiceEl = qs("#ogp-preview-indice");
    const previewTrattamentoEl = qs("#ogp-preview-trattamento");
    const previewTipoEl = qs("#ogp-preview-tipo");
    const previewPrezzoEl = qs("#ogp-preview-prezzo");
    const previewTotaleEl = qs("#ogp-preview-totale");

    const btnStep1Next = qs("#ogp-step1-next");
    const btnStep2Next = qs("#ogp-step2-next");
    const btnStep3Next = qs("#ogp-step3-next");
    const summaryDiv = qs("#ogp-summary");

    const fileInput = qs("#prescription_file");
    const fileInfo = qs("#prescription_file_info");

    const config = {
      productHandle: getUrlParam("product") || null,
      frameVariantId: safeNum(getUrlParam("variant")),
      frameTitle: "",
      frameVariantTitle: "",
      frameImage: "",
      framePriceCents: 0,
      indice: null,
      treatmentKey: null,
      editMode: isEditMode(),
      editGroup: (getUrlParam("group") || "").trim(),
      prescriptionFile: null
    };

    function syncSelectionsFromDOM() {
      const idxBtn =
        document.querySelector('[data-indice][aria-pressed="true"]') ||
        document.querySelector(".ogp-choice-btn.is-active[data-indice]") ||
        document.querySelector(".ogp-choice-btn.active[data-indice]");

      const trtBtn =
        document.querySelector('[data-treatment][aria-pressed="true"]') ||
        document.querySelector(".ogp-card-btn.is-active[data-treatment]") ||
        document.querySelector(".ogp-card-btn.active[data-treatment]");

      if (idxBtn) config.indice = idxBtn.getAttribute("data-indice");
      if (trtBtn) config.treatmentKey = trtBtn.getAttribute("data-treatment");
    }

    if (fileInput) {
      fileInput.addEventListener("change", () => {
        const f = fileInput.files && fileInput.files[0] ? fileInput.files[0] : null;
        config.prescriptionFile = f;
        if (fileInfo) fileInfo.textContent = f ? `File selezionato: ${f.name}` : "Nessun file caricato.";
      });
    }

    function showStep(step) {
      steps.forEach(s => {
        const n = Number(s.getAttribute("data-step"));
        s.style.display = (n === step) ? "" : "none";
      });

      navItems.forEach(n => {
        const s = Number(n.getAttribute("data-step"));
        n.classList.toggle("active", s === step);
      });

      if (progressBar) {
        const pct = Math.round(((step - 1) / 3) * 100);
        progressBar.style.width = `${pct}%`;
      }

      if (step === 4) renderSummary();
    }

    qsa(".ogp-back").forEach(b => {
      b.addEventListener("click", () => {
        const prev = Number(b.getAttribute("data-prev"));
        if (prev) showStep(prev);
      });
    });

    async function autodetectEditGroupFromCartIfMissing() {
      if (config.editMode && config.editGroup) return;
      if (!config.frameVariantId) return;

      const cart = await fetchJson("/cart.js");
      const frames = (cart.items || []).filter(it =>
        it.variant_id === config.frameVariantId &&
        it.properties &&
        it.properties._ogp_group
      );

      if (frames.length) {
        const g = frames[frames.length - 1].properties._ogp_group;
        if (g) {
          config.editMode = true;
          config.editGroup = String(g);
        }
      }
    }

    async function loadFrame() {
      if (!config.productHandle) {
        if (frameNameEl) frameNameEl.textContent = "Nessuna montatura selezionata";
        return;
      }

      const prod = await fetchJson(`/products/${config.productHandle}.js`);
      const variants = Array.isArray(prod.variants) ? prod.variants : [];
      if (!config.frameVariantId && variants.length) config.frameVariantId = variants[0].id;

      const chosen = variants.find(v => v.id === config.frameVariantId) || variants[0];

      config.frameTitle = prod.title || config.productHandle;
      config.frameVariantTitle = chosen ? chosen.title : "";
      config.framePriceCents = chosen ? safeNum(chosen.price) : safeNum(prod.price);

      const vImg = chosen && chosen.featured_image ? chosen.featured_image.src : null;
      config.frameImage = vImg || prod.featured_image || "";

      if (frameNameEl) {
        frameNameEl.textContent = config.frameTitle + (config.frameVariantTitle ? ` (${config.frameVariantTitle})` : "");
      }
      if (frameImgEl && config.frameImage) frameImgEl.src = config.frameImage;
    }

    function calcLensCents() {
      if (!config.indice) return { base: 0, addon: 0, total: 0 };
      const map = OGP_LENS_MAP[config.indice];
      if (!map) return { base: 0, addon: 0, total: 0 };

      const base = safeNum(map.base.priceCents);
      let addon = 0;

      const key = config.treatmentKey;
      if (key && key !== "uv") {
        const included = Array.isArray(map.base.includes) ? map.base.includes : [];
        if (!included.includes(key)) {
          const a = map.addons && map.addons[key];
          addon = a ? safeNum(a.priceCents) : 0;
        }
      }
      return { base, addon, total: base + addon };
    }

    function calcTotalCents() {
      const lens = calcLensCents();
      const frame = safeNum(config.framePriceCents);
      return { frame, lens: lens.total, total: frame + lens.total, lensBreak: lens };
    }

    function setPreview() {
      if (previewIndiceEl) previewIndiceEl.textContent = config.indice || "—";
      const t = OGP_TREATMENTS.find(x => x.key === config.treatmentKey);
      if (previewTrattamentoEl) previewTrattamentoEl.textContent = t ? t.label : "—";
      const map = OGP_LENS_MAP[config.indice || ""];
      if (previewTipoEl) previewTipoEl.textContent = map ? map.label : "—";

      const tot = calcTotalCents();
      if (previewPrezzoEl) {
        previewPrezzoEl.textContent =
          `Montatura: ${money(tot.frame)} — Lenti: ${money(tot.lensBreak.total)} (Base ${money(tot.lensBreak.base)} + Add-on ${money(tot.lensBreak.addon)})`;
      }
      if (previewTotaleEl) previewTotaleEl.textContent = `Totale: ${money(tot.total)}`;
      if (btnStep1Next) btnStep1Next.disabled = !(config.indice && config.treatmentKey);
    }

    function renderIndici() {
      const indici = Object.keys(OGP_LENS_MAP);

      indiceContainer.innerHTML = indici.map(idx => {
        const isOn = (config.indice === idx);
        const pressed = isOn ? "true" : "false";
        const active = isOn ? "is-active" : "";
        return `<button type="button"
          class="ogp-choice-btn ${active}"
          data-indice="${idx}"
          aria-pressed="${pressed}">${idx}</button>`;
      }).join("");

      indiceContainer.onclick = (ev) => {
        const btn = ev.target.closest("[data-indice]");
        if (!btn) return;

        const idx = btn.getAttribute("data-indice");
        config.indice = idx;
        config.treatmentKey = null;

        qsa("[data-indice]", indiceContainer).forEach(b => {
          const on = (b === btn);
          b.classList.toggle("is-active", on);
          b.setAttribute("aria-pressed", on ? "true" : "false");
        });

        renderTrattamenti();
        setPreview();
      };
    }

    function renderTrattamenti() {
      if (!config.indice) {
        trattamentiContainer.innerHTML = `<p class="ogp-step-mini">Seleziona prima un indice.</p>`;
        return;
      }

      const idx = config.indice;
      const map = OGP_LENS_MAP[idx];
      const included = Array.isArray(map.base.includes) ? map.base.includes : [];
      const avail = OGP_TREATMENTS.filter(t => (t.availableFor || []).includes(idx));

      trattamentiContainer.innerHTML = avail.map(t => {
        const isOn = (config.treatmentKey === t.key);
        const active = isOn ? "is-active" : "";
        const pressed = isOn ? "true" : "false";

        const isInc = included.includes(t.key);
        const addon = map.addons && map.addons[t.key];
        const delta = isInc ? "Incluso" : (addon ? `+${money(addon.priceCents)}` : "");

        return `
          <button type="button"
            class="ogp-card-btn ${active}"
            data-treatment="${t.key}"
            aria-pressed="${pressed}">
            <div style="display:flex;justify-content:space-between;gap:12px;align-items:baseline;">
              <strong>${t.label}</strong>
              <span class="ogp-card-price">${delta}</span>
            </div>
          </button>
        `;
      }).join("");

      trattamentiContainer.onclick = (ev) => {
        const btn = ev.target.closest("[data-treatment]");
        if (!btn) return;

        const key = btn.getAttribute("data-treatment");
        config.treatmentKey = key;

        qsa("[data-treatment]", trattamentiContainer).forEach(b => {
          const on = (b === btn);
          b.classList.toggle("is-active", on);
          b.setAttribute("aria-pressed", on ? "true" : "false");
        });

        setPreview();
      };
    }

    function getRxAndPdProps() {
      const v = (id) => (qs(id) ? String(qs(id).value || "").trim() : "");

      return {
        _ogp_od_sph: v("#od_sph"),
        _ogp_od_cyl: v("#od_cyl"),
        _ogp_od_axis: v("#od_axis"),
        _ogp_os_sph: v("#os_sph"),
        _ogp_os_cyl: v("#os_cyl"),
        _ogp_os_axis: v("#os_axis"),
        _ogp_pd_dx: v("#pd_dx"),
        _ogp_pd_sx: v("#pd_sx")
      };
    }

    function validateStep2() {
      const od_sph = (qs("#od_sph")?.value || "").trim();
      const os_sph = (qs("#os_sph")?.value || "").trim();
      const hasFile = !!config.prescriptionFile;

      if (hasFile) return { ok: true, missing: [] };

      const missing = [];
      if (!od_sph) missing.push("Inserisci SPH Occhio Destro (OD) oppure carica la ricetta.");
      if (!os_sph) missing.push("Inserisci SPH Occhio Sinistro (OS) oppure carica la ricetta.");
      return { ok: missing.length === 0, missing };
    }

    function validateStep3() {
      const pd_dx = (qs("#pd_dx")?.value || "").trim();
      const pd_sx = (qs("#pd_sx")?.value || "").trim();

      const missing = [];
      if (!pd_dx) missing.push("Inserisci PD Destro (DX).");
      if (!pd_sx) missing.push("Inserisci PD Sinistro (SX).");

      return { ok: missing.length === 0, missing };
    }

    function renderSummary() {
      if (!summaryDiv) return;

      const t = OGP_TREATMENTS.find(x => x.key === config.treatmentKey);
      const tot = calcTotalCents();
      const rx = getRxAndPdProps();

      summaryDiv.innerHTML = `
        <div class="ogp-summary-block">
          <h3>Montatura</h3>
          <p>${config.frameTitle || "—"} ${config.frameVariantTitle ? `(${config.frameVariantTitle})` : ""}</p>
        </div>

        <div class="ogp-summary-block">
          <h3>Lenti</h3>
          <p><strong>Indice:</strong> ${config.indice || "—"}</p>
          <p><strong>Trattamento:</strong> ${(t && t.label) || "—"}</p>
          <p><strong>Tipo:</strong> ${(OGP_LENS_MAP[config.indice || ""] && OGP_LENS_MAP[config.indice || ""].label) || "—"}</p>
        </div>

        <div class="ogp-summary-block">
          <h3>Prescrizione</h3>
          <p><strong>OD:</strong> SPH ${rx._ogp_od_sph || "—"} | CYL ${rx._ogp_od_cyl || "—"} | AX ${rx._ogp_od_axis || "—"}</p>
          <p><strong>OS:</strong> SPH ${rx._ogp_os_sph || "—"} | CYL ${rx._ogp_os_cyl || "—"} | AX ${rx._ogp_os_axis || "—"}</p>
          <p><strong>PD:</strong> DX ${rx._ogp_pd_dx || "—"} | SX ${rx._ogp_pd_sx || "—"}</p>
          <p><strong>Ricetta:</strong> ${config.prescriptionFile ? config.prescriptionFile.name : "Non caricata"}</p>
        </div>

        <div class="ogp-summary-block">
          <h3>Totale (anteprima)</h3>
          <p>Montatura: ${money(tot.frame)}</p>
          <p>Lenti: ${money(tot.lensBreak.total)} (Base ${money(tot.lensBreak.base)} + Add-on ${money(tot.lensBreak.addon)})</p>
          <p><strong>Totale:</strong> ${money(tot.total)}</p>
        </div>
      `;
    }

    function buildBundleItems(groupId) {
      const map = OGP_LENS_MAP[config.indice];
      if (!map || !map.base || !map.base.id) return [];

      const baseId = map.base.id;
      const included = Array.isArray(map.base.includes) ? map.base.includes : [];
      const t = OGP_TREATMENTS.find(x => x.key === config.treatmentKey);
      const treatmentLabel = t ? t.label : (config.treatmentKey || "");
      const lensTipo = map.label || "";

      const rxProps = getRxAndPdProps();

      const sharedProps = {
        _ogp_group: groupId,
        _ogp_indice: config.indice || "",
        _ogp_trattamento: treatmentLabel || "",
        _ogp_tipo: lensTipo || "",
        ...rxProps
      };

      const items = [
        { id: Number(config.frameVariantId), quantity: 1, properties: { ...sharedProps, _ogp_role: "frame" } },
        { id: Number(baseId), quantity: 1, properties: { ...sharedProps, _ogp_role: "lens-base", _ogp_lens_part: "base" } }
      ];

      const key = config.treatmentKey;
      if (key && key !== "uv" && !included.includes(key)) {
        const addon = map.addons && map.addons[key];
        if (addon && addon.id) {
          items.push({ id: Number(addon.id), quantity: 1, properties: { ...sharedProps, _ogp_role: "lens-addon", _ogp_lens_part: "addon" } });
        }
      }

      return items;
    }

    function getVariantIdsFromItems(items) {
      return (items || []).map(it => Number(it.id)).filter(Boolean);
    }

    async function addItemsWithRetry(items, groupId, file) {
      const idsToClean = getVariantIdsFromItems(items);

      const tryOnce = async () => {
        if (!file) {
          await cartAddJson(items);
          return;
        }

        // con file: aggiungo in sequenza via FormData.
        // Il file lo attacco alla riga della montatura (role frame).
        for (const it of items) {
          const attach = (it.properties && it.properties._ogp_role === "frame") ? file : null;
          await cartAddFormDataOne(it, attach, "Ricetta (PDF/FOTO)");
        }
      };

      try {
        await tryOnce();
        return;
      } catch (err) {
        const body = String(err.body || err.message || "");
        const is422 = Number(err.status) === 422 || body.includes('"status":422') || body.includes("422");
        const looksLikeMaxQty = body.toLowerCase().includes("quantità massima") || body.toLowerCase().includes("massima consentita");
        if (!(is422 && looksLikeMaxQty)) throw err;

        if (groupId) {
          try { await removeAllItemsInGroup(groupId); } catch (_) {}
        }
        await removeItemsByVariantIds(idsToClean);

        await tryOnce();
      }
    }

    if (btnStep1Next) {
      btnStep1Next.addEventListener("click", () => {
        syncSelectionsFromDOM();
        if (!config.indice || !config.treatmentKey) {
          showModal("Selezione mancante", "Scegli indice e trattamento per continuare.", ["Indice", "Trattamento"]);
          return;
        }
        showStep(2);
      });
    }

    if (btnStep2Next) {
      btnStep2Next.addEventListener("click", () => {
        const v = validateStep2();
        if (!v.ok) {
          showModal("Mancano alcuni dati", "Completa almeno SPH OD/OS oppure carica la ricetta.", v.missing);
          return;
        }
        showStep(3);
      });
    }

    if (btnStep3Next) {
      btnStep3Next.addEventListener("click", () => {
        const v = validateStep3();
        if (!v.ok) {
          showModal("PD mancante", "Inserisci la distanza interpupillare per continuare.", v.missing);
          return;
        }
        showStep(4);
      });
    }

    async function addToCartFlow() {
      syncSelectionsFromDOM();

      if (!config.indice || !config.treatmentKey) {
        showModal("Selezione mancante", "Scegli indice e trattamento.", ["Indice", "Trattamento"]);
        return;
      }
      if (!config.productHandle || !config.frameVariantId) {
        showModal("Montatura non valida", "Torna alla montatura e riprova.", ["Variant ID mancante"]);
        return;
      }

      await autodetectEditGroupFromCartIfMissing();

      const groupId = config.editMode ? (config.editGroup || "") : buildGroupId();
      if (config.editMode && !groupId) {
        showModal("Modifica non valida", "Manca il group per la modifica.", ["Parametro group"]);
        return;
      }

      if (config.editMode) {
        await removeAllItemsInGroup(groupId);
      }

      const items = buildBundleItems(groupId);
      const bad = items.find(it => !it.id || !Number.isFinite(Number(it.id)) || Number(it.quantity) <= 0);
      if (bad) {
        console.error("OGP bad item payload:", items);
        showModal("Errore tecnico", "ID prodotto non valido. Controlla console.", [JSON.stringify(bad)]);
        return;
      }

      await addItemsWithRetry(items, config.editMode ? groupId : null, config.prescriptionFile);
      window.location.href = "/cart";
    }

    if (addToCartBtn) {
      const run = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        addToCartBtn.disabled = true;
        addToCartBtn.setAttribute("aria-busy", "true");

        try {
          await addToCartFlow();
        } catch (err) {
          console.error("OGP addToCart error:", err);
          showModal("Errore aggiunta al carrello", "Si è verificato un errore tecnico.", [String(err.message || err)]);
          addToCartBtn.disabled = false;
          addToCartBtn.removeAttribute("aria-busy");
        }
      };

      addToCartBtn.addEventListener("click", run, { passive: false });
    }

    // init UI
    await loadFrame();
    renderIndici();
    renderTrattamenti();
    setPreview();
    showStep(1);
  }

  document.addEventListener("DOMContentLoaded", () => {
    patchConfiguratorLinks();
    initConfiguratorIfPresent().catch(err => console.error("OGP init error:", err));
  });
})();